import _this from '../main'
/**
 * @description 带小数点的数字(不可为0)
 */
export function pointNum(rule, value, callback) {
  var max = 0,
    min = 0,
    length = rule.length,
    type = rule.type || '',
    lengthMes = rule.lengthMes != 'string' ? rule.lengthMes : ''
  if (rule.options && rule.options.max !== null) {
    max = rule.options.max
    min = rule.options.min
  }
  if (/^(([1-9]{1}\d*)|(0{1}))(\.\d{1,9})$/.test(value)) {
    rule.options
      ? value > max || value == max
        ? callback(new Error(`${type}` + '  ' + _this.$t('数字范围') + '  ' + `${min}-${max}`))
        : length && value && value.toString().split('.')[1] && value.toString().split('.')[1].length > length
        ? callback(new Error(`${lengthMes}`))
        : value == 0
        ? callback(new Error(`${type}` + '  ' + _this.$t('数字范围') + '  ' + `${min}-${max}`))
        : callback()
      : callback()
  } else if (/^(0|[1-9][0-9]*)$/.test(value)) {
    rule.options
      ? value > max || value == max
        ? callback(new Error(`${type}` + '  ' + _this.$t('数字范围') + '  ' + `${min}-${max}`))
        : value == 0
        ? callback(new Error(`${type}` + '  ' + _this.$t('数字范围') + '  ' + `${min}-${max}`))
        : callback()
      : callback()
  } else if (value < 0) {
    callback(new Error(`${type}` + '  ' + _this.$t('数字范围') + '  ' + `${min}-${max}`))
  } else {
    !value ? callback() : callback(new Error(_this.$t('请输入合法数字')))
  }
}
/**
 * @description 带小数点的数字(不可为0)
 */
export function pointNumNew(rule, value, callback) {
  var max = 0,
    min = 0,
    length = rule.length,
    type = rule.type || '',
    lengthMes = rule.lengthMes != 'string' ? rule.lengthMes : ''
  if (rule.options && rule.options.max !== null) {
    max = rule.options.max
    min = rule.options.min
  }
  if (/^(([1-9]{1}\d*)|(0{1}))(\.\d{1,9})$/.test(value)) {
    rule.options
      ? value > max || value == max
        ? callback(new Error(type))
        : length && value && value.toString().split('.')[1] && value.toString().split('.')[1].length > length
        ? callback(new Error(lengthMes))
        : value == 0
        ? callback(new Error(type))
        : callback()
      : callback()
  } else if (/^(0|[1-9][0-9]*)$/.test(value)) {
    rule.options ? (value > max || value == max ? callback(new Error(type)) : value == 0 ? callback(new Error(type)) : callback()) : callback()
  } else if (value < 0) {
    callback(new Error(type))
  } else {
    !value ? callback() : callback(new Error(_this.$t('请输入合法数字')))
  }
}
/**
 * @description 带小数点的数字(可以为0)
 */
export function pointNumZero(rule, value, callback) {
  var min = 0,
    max = 0,
    length = rule.length,
    type = rule.type != 'string' ? rule.type : '',
    lengthMes = rule.lengthMes != 'string' ? rule.lengthMes : ''
  if (rule.options && rule.options.min != null) {
    min = rule.options.min
  }
  if (rule.options && rule.options.max != null) {
    max = rule.options.max
  }
  if (/^(([1-9]{1}\d*)|(0{1}))(\.\d*)$/.test(value)) {
    rule.options
      ? value < min || value > max
        ? callback(`${type}` + '  ' + _this.$t('数字范围') + '  ' + `${min}-${max}`)
        : length && value && value.toString().split('.')[1] && value.toString().split('.')[1].length > length
        ? callback(`${lengthMes}`)
        : callback()
      : callback()
  } else if (/^(0|[1-9][0-9]*)$/.test(value)) {
    rule.options && (value < min || value > max) ? callback(`${type}` + '  ' + _this.$t('数字范围') + '  ' + `${min}-${max}`) : callback()
  } else {
    !value ? callback() : callback(_this.$t('请输入合法数字'))
  }
}
/**
 * @description 正负带小数点的数字(可以为0)
 */
export function pointNumMinusZero(rule, value, callback) {
  var min = 0,
    max = 0,
    length = rule.length,
    type = rule.type != 'string' ? rule.type : '',
    lengthMes = rule.lengthMes != 'string' ? rule.lengthMes : ''
  if (rule.options && rule.options.min != null) {
    min = rule.options.min
  }
  if (rule.options && rule.options.max != null) {
    max = rule.options.max
  }
  if (/^[-]?((([1-9]{1}\d*)|(0{1}))(\.\d*))$/.test(value)) {
    rule.options
      ? value < min || value > max
        ? callback(`${type}` + '  ' + _this.$t('数字范围') + '  ' + `${min}-${max}`)
        : length && value && value.toString().split('.')[1] && value.toString().split('.')[1].length > length
        ? callback(`${lengthMes}`)
        : callback()
      : callback()
  } else if (/^[-]?((0|[1-9][0-9]*))$/.test(value)) {
    rule.options && (value < min || value > max) ? callback(`${type}` + '  ' + _this.$t('数字范围') + '  ' + `${min}-${max}`) : callback()
  } else {
    !value ? callback() : callback(_this.$t('请输入合法数字'))
  }
}
/**
 * @description 验证手机号
 */
export function isMobile(rule, value, callback) {
  var reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
  if (value === '' || value === null) {
    callback()
    return
  }
  if (!reg.test(value)) {
    callback(new Error(_this.$t('手机号码格式不正确')))
  } else {
    callback()
  }
}

/**
 * @description 邮箱
 */
export function isEmail(rule, value, callback) {
  var reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  if (value) {
    if (!reg.test(value)) {
      callback(new Error(_this.$t('邮箱格式不正确')))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
//大于0数字
export function isNumber(rule, value, callback) {
  var reg = /^(?!(0[0-9]{0,}$))[0-9]{1,}[.]{0,}[0-9]{0,}$/
  if (value) {
    if (!reg.test(value)) {
      callback(new Error(_this.$t('请输入大于0数字')))
    } else {
      callback()
    }
  } else {
    callback()
  }
}
/**
 * @description 校验密码（6-16，大小写字母、数字、特殊符号 !#$%^_&*-）
 */
export function isPassword(rule, value, callback) {
  var reg = /^(?=.*[A-Za-z\d])[\w!~!@#$%^&*()_+`\-={}:";'<>?,.\/]{6,20}$/

  if (!reg.test(value)) {
    callback(new Error(_this.$t('密码必须由6至20个字符组成支持字母不区分大小写数字和特殊符号')))
  } else {
    callback()
  }
}
/**
 * @description 正整数
 */
export function integer(rule, value, callback) {
  var min = 0,
    max = 0,
    type = rule.type != 'string' ? rule.type : ''
  if (rule.options && rule.options.min != null) {
    min = rule.options.min
  }
  if (rule.options && rule.options.max != null) {
    max = rule.options.max
  }
  if (/^(0|[1-9][0-9]*)$/.test(value)) {
    rule.options && (value < min || value > max) ? callback(_this.$t('数字范围') + '  ' + `${min}-${max}` + '  ' + _this.$t('整数')) : callback()
  } else {
    !value ? callback() : callback(_this.$t('数字范围') + '  ' + `${min}-${max}` + '  ' + _this.$t('整数'))
  }
}
/**
 * @description 正整数
 */
export function integerNew(rule, value, callback) {
  var min = 0,
    max = 0,
    typeMsg = rule.typeMsg
  if (rule.options && rule.options.min != null) {
    min = rule.options.min
  }
  if (rule.options && rule.options.max != null) {
    max = rule.options.max
  }
  if (/^(0|[1-9][0-9]*)$/.test(value)) {
    rule.options && (value < min || value > max) ? callback(typeMsg) : callback()
  } else {
    !value ? callback() : callback(typeMsg)
  }
}

/**
 * @description 正整数-新
 */
// export function integerNew(rule, value, callback) {
//   var min = 0,
//     max = 0,
//     typeMsg = rule.typeMsg
//   if (rule.options && rule.options.min != null) {
//     min = rule.options.min
//   }
//   if (rule.options && rule.options.max != null) {
//     max = rule.options.max
//   }
//   if (/^(0|[1-9][0-9]*)$/.test(value)) {
//     rule.options && (value < min || value > max) ? callback(_this.$t(typeMsg)) : callback()
//   } else {
//     !value ? callback() : callback(_this.$t(typeMsg))
//   }
// }
/**
 * @description 正负整数
 */
export function integerSign(rule, value, callback) {
  var min = 0,
    max = 0,
    type = rule.type != 'string' ? rule.type : ''
  if (rule.options && rule.options.min != null) {
    min = rule.options.min
  }
  if (rule.options && rule.options.max != null) {
    max = rule.options.max
  }
  if (/^(0|[1-9][0-9]*|-[1-9][0-9]*)$/.test(value)) {
    rule.options && (value < min || value > max) ? callback(_this.$t('数字范围') + '  ' + `${min}-${max}` + '  ' + _this.$t('整数')) : callback()
  } else {
    !value ? callback() : callback(_this.$t('数字范围') + '  ' + `${min}-${max}` + '  ' + _this.$t('整数'))
  }
}
export function integerSignNew(rule, value, callback) {
  var min = 0,
    max = 0,
    type = rule.type != 'string' ? rule.type : '',
    typeMes = rule.typeMes
  if (rule.options && rule.options.min != null) {
    min = rule.options.min
  }
  if (rule.options && rule.options.max != null) {
    max = rule.options.max
  }
  if (/^(0|[1-9][0-9]*|-[1-9][0-9]*)$/.test(value)) {
    rule.options && (value < min || value > max) ? callback(typeMes) : callback()
  } else {
    !value ? callback() : callback(typeMes)
  }
}
// export function isPassword(rule, value, callback) {
//   var reg = /^(?=.*[A-Za-z\d])[\w!@#$%^&*()]{6,20}$/

//   if (!reg.test(value)) {
//     callback(new Error('密码格式不正确，6-20位大小写字母、数字、特殊符号组合'))
//   } else {
//     callback()
//   }
// }
